<template>
  <div>
    <div v-for="item in items" :key="item.key" class="item-row border-top">

      <label class="d-flex align-items-start mb-0 py-2 pr-3"
             :class="[indented ? 'pl-5' : 'pl-3', disabled ? 'disabled' : 'pointer']">
        <bkps-check-box
            :disabled="disabled"
            :value="selected.includes(id(item))"
            @input="$emit('toggle', id(item), $event)"/>
        <span class="ml-2">
          <strong class="item-label">{{ item.label }}</strong>
          <small v-if="item.flag" class="badge badge-light ml-1">{{ item.flag }}</small>
          <span v-if="item.hint" class="d-block text-muted item-hint">{{ item.hint }}</span>
        </span>
      </label>

      <!-- Escolher "quais" é continuação de "ver": o recorte aparece colado na
           permissão, e só depois que ela está marcada. -->
      <div v-if="selected.includes(id(item)) && inlineScopes(item).length"
           class="scope-block"
           :class="indented ? 'pl-5' : 'pl-4'">
        <div v-for="dimension in inlineScopes(item)" :key="dimension.key" class="mb-3">

          <slot v-if="dimension.kind === 'companies'" name="companies" :dimension="dimension"/>

          <template v-else>
            <div>
              <strong class="small">{{ title(dimension) }}</strong>
              <small v-if="dimension.dynamic" class="badge badge-light ml-1"
                     title="A lista vem da conta: só aparece o que realmente tem registro neste produto">
                vem da conta
              </small>
              <a v-if="!disabled && hidden(dimension).length"
                 class="small text-muted ml-2 pointer"
                 @click="$emit('scope-clear', app, dimension.key)">limpar</a>
            </div>

            <p v-if="options(dimension).length === 0" class="small text-muted mb-1">
              Nenhum valor nesta conta ainda — não há o que ocultar.
            </p>
            <div v-else class="mt-1">
              <input v-if="searchable(dimension)"
                     class="form-control form-control-sm mb-2 scope-search"
                     placeholder="Buscar..."
                     :value="searches[searchKey(dimension)] || ''"
                     @input="setSearch(dimension, $event.target.value)">
              <p v-if="visibleOptions(dimension).length === 0" class="small text-muted mb-1">
                Nenhum valor encontrado.
              </p>
              <button v-for="option in visibleOptions(dimension)" :key="option.value"
                      type="button"
                      class="btn btn-sm scope-option mr-1 mb-1"
                      :class="hidden(dimension).includes(option.value) ? 'blocked' : 'free'"
                      :disabled="disabled"
                      @click="$emit('scope-toggle', app, dimension.key, option.value)">
                {{ option.label }}
              </button>
            </div>

            <small class="d-block text-muted">{{ dimension.hint }}</small>
          </template>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import BkpsCheckBox from '@/components/shares/specialTag/BkpsCheckBox'
  import {
    SCOPE_SEARCH_THRESHOLD, filterScopeOptions, inlineScopesFor, permissionId, scopeOptions, scopeTitle
  } from '@/models/permissionCatalog'

  export default {
    components: { BkpsCheckBox },
    data: () => ({
      searches: {}
    }),
    methods: {
      hidden(dimension) {
        return (this.scopes[this.app] || {})[dimension.key] || []
      },
      id(item) {
        return permissionId(this.app, item.key)
      },
      inlineScopes(item) {
        return inlineScopesFor(this.dimensions, this.app, this.section, item.key, this.subtab)
      },
      options(dimension) {
        return scopeOptions(dimension, this.app)
      },
      searchable(dimension) {
        return this.options(dimension).length > SCOPE_SEARCH_THRESHOLD
      },
      searchKey(dimension) {
        return `${this.app}:${dimension.key}`
      },
      setSearch(dimension, value) {
        this.$set(this.searches, this.searchKey(dimension), value)
      },
      title(dimension) {
        return scopeTitle(dimension)
      },
      visibleOptions(dimension) {
        const options = this.options(dimension)
        if (!this.searchable(dimension)) return options
        return filterScopeOptions(options, this.searches[this.searchKey(dimension)])
      }
    },
    name: 'PermissionItemList',
    props: {
      app: { required: true },
      dimensions: { default: () => [] },
      disabled: { default: false },
      indented: { default: false },
      items: { required: true },
      scopes: { default: () => ({}) },
      section: { required: true },
      selected: { default: () => [] },
      subtab: { default: undefined }
    }
  }
</script>

<style scoped>
  .pointer { cursor: pointer; }
  .disabled { opacity: .7; }
  .item-label { font-size: 14px; }
  .item-hint { font-size: 12.5px; }
  .item-row:first-child { border-top: 0 !important; }
  .scope-block { border-left: 2px solid rgba(0, 123, 255, .2); background: rgba(0, 0, 0, .02); padding-top: .5rem; padding-bottom: .5rem; padding-right: 1rem; }
  .scope-search { max-width: 320px; }
  .scope-option { border-radius: 1rem; font-size: 11px; padding: .05rem .6rem; }
  .scope-option.free { border: 1px solid #ced4da; color: #6c757d; }
  .scope-option.blocked { border: 1px solid rgba(220, 53, 69, .3); background: rgba(220, 53, 69, .1); color: #c82333; text-decoration: line-through; }
</style>
